import { ChoiceListElement } from '../types/choice-list-element.interface';
import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';

export const choiceListElementDefinition: EntityDefinition<ChoiceListElement> = {
  entityType: 'ChoiceListElement',
  i18nBase: 'entities.choiceListElement',
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'common.labels.name',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  fields: [{ field: 'name', labelKey: 'common.labels.name', required: true, type: 'text', minLength: 2, maxLength: 50 }],
  validationRules: [
    {
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: ChoiceListElement) => !entity.isUsed,
      errorMessageKey: 'entities.choiceListElement.messages.deleteError',
    },
    {
      type: BusinessRuleType.CREATE_VALIDATION,
      rule: (entity: ChoiceListElement, store) => {
        if (!store) return true;
        const elements = store.getData('ChoiceListElement')();
        return !(elements as ChoiceListElement[]).some(
          e => e.choiceListId === entity.choiceListId && e.name.toLowerCase().trim() === entity.name.toLowerCase().trim(),
        );
      },
      errorMessageKey: 'entities.choiceListElement.messages.duplicateError',
    },
    {
      type: BusinessRuleType.EDIT_VALIDATION,
      rule: (entity: ChoiceListElement, store) => {
        if (!store) return true;
        const elements = store.getData('ChoiceListElement')();
        return !(elements as ChoiceListElement[]).some(
          e =>
            e.choiceListId === entity.choiceListId &&
            e.name.toLowerCase().trim() === entity.name.toLowerCase().trim() &&
            e.id !== entity.id,
        );
      },
      errorMessageKey: 'entities.choiceListElement.messages.duplicateError',
    },
  ],
  actionButtons: {
    parent: {
      edit: false,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.choiceListElement.messages.createTitle',
      edit: () => 'entities.choiceListElement.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.choiceListElement.messages.addButton',
      create: () => 'entities.choiceListElement.messages.addButton',
      edit: () => 'entities.choiceListElement.messages.editTitleWithName',
      delete: () => 'entities.choiceListElement.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.choiceListElement.messages.deleteConfirm',
  },
};
